<template>
    <div class="container border">
        <img src="@/assets/img/card/examOver.png" class="img" @click="rotateImage">
    </div>
</template>

<script>
export default {
    methods: {
        rotateImage(event) {
            event.target.classList.add('rotate'); // 添加 'rotate' 类到 img 上
            setTimeout(() => event.target.classList.remove('rotate'), 1000); // 旋转后移除 'rotate' 类，为下一次点击做准备
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.img {
    width: 400px;
    transition: width 400ms; /* 保持 hover 效果 */
}

.img:hover{
    width: 500px;
    cursor: pointer;
}

.rotate {
    animation: rotation 1s forwards; /* 动画持续时间与一次旋转时间相同 */
}

@keyframes rotation {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>